module.exports = __webpack_public_path__ + "static/img/gtxd.b9df61c2.png";